import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BenefitsSection.css';

const BenefitsSection = ({ 
  title, 
  trustBadges = [], 
  benefits = [],
  className = '',
  isInlineInHero = false // New prop to indicate if rendered inside HeroSection
}) => {
  // Conditionally adjust section class if rendered in hero
  const sectionClasses = `benefits-section ${className} ${isInlineInHero ? 'benefits-section-inline-in-hero' : ''}`;

  return (
    <section className={sectionClasses}>
      <Container>
        {title && <h4 className="section-title">{title}</h4>}
        
        {trustBadges.length > 0 && (
          <div className="trust-badges">
            {trustBadges.map((badge, index) => (
              <div className="trust-badge" key={index}>
                <div className="trust-badge-value">{badge.value}</div>
                <div className="trust-badge-label">{badge.label}</div>
              </div>
            ))}
          </div>
        )}
        
        <Row className="benefits-row gy-4">
          {benefits.map((benefit, index) => (
            <Col 
              lg={benefits.length <= 3 ? 4 : 3} 
              md={6} 
              sm={12} 
              key={index}
              className="mb-4"
            >
              <div className="benefit-card h-100">
                <div className="benefit-icon-wrapper">
                  {benefit.icon}
                </div>
                <div className="benefit-text-content"> {/* New wrapper for title and description */}
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default BenefitsSection;
